import { BUTTON_VARIANT } from './constants.js';

var getTextColor = function getTextColor(variant, hover, active, disabled, theme) {
  switch (variant) {
    case BUTTON_VARIANT.TERTIARY:
    case BUTTON_VARIANT.TERTIARY_BACK:
    case BUTTON_VARIANT.TERTIARY_NOICON:
      if (disabled) {
        return theme.colorPalette.neutralColors.light.shade_dark_2;
      }

      return theme.colorPalette.neutralColors.dark.shade_default;

    case BUTTON_VARIANT.SIGN_IN:
      return theme.colorPalette.neutralColors.dark.shade_light_1;

    case BUTTON_VARIANT.SECONDARY:
      if (active) {
        return theme.colorPalette.neutralColors.light.shade_white;
      }

      if (disabled) {
        return theme.colorPalette.neutralColors.light.shade_light_2;
      }

      if (hover) {
        return theme.colorPalette.neutralColors.light.shade_white;
      }

      return theme.colorPalette.accentColor.shade_dark_1;

    default:
      if (active) {
        return theme.colorPalette.neutralColors.light.shade_white;
      }

      if (disabled) {
        return theme.colorPalette.neutralColors.light.shade_light_2;
      }

      return theme.colorPalette.neutralColors.light.shade_white;
  }
};

export { getTextColor };
